import { getPostponedDate } from './utils/getPostponedDate';

const localStorageDesktopAppNoticeCacheKey = '_desktop-app-notice-cache';

export type DesktopAppNoticeCache = {
  expiresAt?: number;
};

export type DesktopAppNoticeCacheArgs = {
  daysToPostpone?: number;
};

/**
 * Sets the expire date to a localStorage cache.
 *
 * @param {DesktopAppNoticeCache}
 */
export function setLocalStorageDesktopAppNoticeCache({
  daysToPostpone = 7,
}: DesktopAppNoticeCacheArgs): void {
  localStorage.setItem(
    localStorageDesktopAppNoticeCacheKey,
    JSON.stringify({
      expiresAt: getPostponedDate(daysToPostpone),
    }),
  );
}

/**
 * Returns the cached value from localStorage.
 *
 * @returns {DesktopAppNoticeCache}
 */
export function getLocalStorageDesktopAppNoticeCache(): DesktopAppNoticeCache {
  const cache = localStorage.getItem(localStorageDesktopAppNoticeCacheKey);

  if (!cache) {
    return {};
  }

  return JSON.parse(cache) || {};
}
